import React, { useState, useEffect } from "react";
import EventRosterDefault from "./EventRoster/EventRosterDefault";
import { useNavigate } from "react-router";
import { handlePlayersChange, userDisplayName } from "./EventFunctions";
import { getArmyPickerArmies } from "../../../components/api/APIUtilities";
import { postNotification } from "../../../components/utilities/Notifications";
import {
  getData,
  newPath,
} from "../../../components/utilities/UtilityFunctions";

export default function EventRoster(props) {
  const { organize, setActiveTab, event, authContext } = props;

  const navigate = useNavigate();

  const [refreshPlayers, setRefreshPlayers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [bulkAddOpen, setBulkAddOpen] = useState(false);
  const [bulkAddEmailsOpen, setBulkAddEmailsOpen] = useState(false);

  const [teamPlayer, setTeamPlayer] = useState(null);

  const [players, setPlayers] = useState(null);

  const [player, setPlayer] = useState(null);

  const [armies, setArmies] = useState(null);

  const [playerStats, setPlayerStats] = useState([
    {
      label: `Registered ${event?.teamEvent ? "Teams" : "Players"}`,
      value: "##",
      color: "info",
    },
    {
      label: `Checked In ${event?.teamEvent ? "Teams" : "Players"}`,
      value: "##",
      color: "warning",
    },
    {
      label: `Active ${event?.teamEvent ? "Teams" : "Players"}`,
      value: "##",
      color: "success",
    },
  ]);

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);

  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);
  const [filteredPlayers, setFilteredPlayers] = useState(null);
  const [filterType, setFilterType] = useState("");

  const fetchPlayers = async () => {
    const returnArray = [];

    try {
      const apiData = await getData(`/events/${event.id}/players`);

      if (apiData && apiData?.active?.length) {
        returnArray.push(...apiData.active);
      }

      if (!returnArray || !returnArray?.length) {
        return [];
      }

      returnArray?.sort((a, b) => {
        var nameA = userDisplayName(
          a?.user?.firstName,
          a?.user?.lastName
        ).toLowerCase();
        var nameB = userDisplayName(
          b?.user?.firstName,
          b?.user?.lastName
        ).toLowerCase();
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
      });
    } catch (err) {
      console.error(err);
    }
    return returnArray;
  };

  const fetchTeamPlayers = async () => {
    var returnArray = [];
    try {
      const apiData = await getData(`/events/${event.id}/teamplayers`);

      returnArray = apiData?.active;

      if (!returnArray || !returnArray?.length) {
        return [];
      }

      returnArray.sort((a, b) => {
        if (a.name?.toLowerCase() > b.name?.toLowerCase()) return 1;
        if (a.name?.toLowerCase() < b.name?.toLowerCase()) return -1;
        return 0;
      });
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  async function parallel() {
    const taskPlayers = fetchPlayers();
    const taskTeamPlayers =
      event?.teamEvent || event?.doublesEvent ? fetchTeamPlayers() : null;

    return {
      players: await taskPlayers,
      teamPlayers: await taskTeamPlayers,
    };
  }

  const handlePlayers = async () => {
    const parallelData = await parallel();

    if (
      (event?.teamEvent || event?.doublesEvent) &&
      parallelData?.teamPlayers?.length &&
      parallelData?.players?.length
    ) {
      // Adds players to teamPlayers
      parallelData?.players?.forEach((player) => {
        if (player?.teamPlayerId) {
          // Add player to teamPlayer
          parallelData?.teamPlayers?.forEach((teamPlayer) => {
            if (teamPlayer?.id === player.teamPlayerId) {
              if (!teamPlayer.players) {
                teamPlayer.players = [];
              }
              teamPlayer.players.push(player);
            }

            if (teamPlayer?.captainId === player.id) {
              teamPlayer.captain = player;
            }
          });
        }
      });

      // Sort players in teams by name
      parallelData?.teamPlayers?.forEach((teamPlayer) => {
        if (teamPlayer?.players && teamPlayer?.players?.length) {
          teamPlayer.players.sort((a, b) => {
            var nameA = userDisplayName(
              a?.user?.firstName,
              a?.user?.lastName
            ).toLowerCase();
            var nameB = userDisplayName(
              b?.user?.firstName,
              b?.user?.lastName
            ).toLowerCase();
            if (nameA > nameB) return 1;
            if (nameA < nameB) return -1;
            return 0;
          });
        }
      });
    }

    const { counters, newPlayerArray } = handlePlayersChange(
      event,
      event?.teamEvent ? parallelData.teamPlayers : parallelData.players,
      {
        showOverall: false,
        isPlacings: false,
      }
    );

    setPlayerStats([
      {
        label: `Registered ${event?.teamEvent ? "Teams" : "Players"}`,
        value: counters?.registered || 0,
        color: "info",
      },
      {
        label: `Checked In ${event?.teamEvent ? "Teams" : "Players"}`,
        value: counters?.checkedin || 0,
        color: "warning",
      },
      {
        label: `Active ${event?.teamEvent ? "Teams" : "Players"}`,
        value: counters?.active || 0,
        color: "success",
      },
    ]);

    setPlayers(newPlayerArray);
  };

  useEffect(() => {
    const check = async () => {
      try {
        if (event) {
          if (!organize && event.hideRoster) {
            postNotification(
              "warning",
              "The Roster is currently being hidden until the organizer reveals it."
            );
            var path = newPath({
              active_tab: "overview",
            });
            setActiveTab(0);
            navigate(path, { replace: false });
            return;
          }
          await handlePlayers();

          if (organize && event.gameSystem?.hasFactions) {
            const { armyArray } = await getArmyPickerArmies(
              event?.gameSystem?.id || event?.gameSystemId
            );
            if (armyArray?.length) {
              setArmies(armyArray);
            }
          } else {
            setArmies(null);
          }
        }
      } catch (err) {
        postNotification("error", err);
      }
      setSubLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const check = async () => {
      try {
        if (!refreshPlayers) return;
        if (event) {
          setSubLoading(true);
          await handlePlayers();
        }
      } catch (err) {
        postNotification("error", err);
      }
      setSubLoading(false);
      setRefreshPlayers(false);
    };
    check();
    // eslint-disable-next-line
  }, [refreshPlayers]);

  useEffect(() => {
    switch (filterType) {
      case "Checked In":
        if (event?.doublesEvent || event?.teamEvent) {
          const tempArr = [];
          let playersCheckedIn = false;
          let teamCheckedIn = false;

          if (players && Array.isArray(players)) {
            players?.forEach((teamPlayer) => {
              teamCheckedIn = false;
              playersCheckedIn = false;

              if (teamPlayer?.checkedIn) {
                teamCheckedIn = true;
              } else {
                teamCheckedIn = false;
              }

              if (teamPlayer?.players) {
                for (const _player of teamPlayer.players) {
                  if (_player?.checkedIn) {
                    playersCheckedIn = true;
                  } else {
                    playersCheckedIn = false;
                    break;
                  }
                }
              }

              if (playersCheckedIn && teamCheckedIn) tempArr.push(teamPlayer);
            });
          }

          setFilteredPlayers(tempArr);
        } else {
          setFilteredPlayers(
            players && Array.isArray(players)
              ? players.filter((player) => player.checkedIn)
              : []
          );
        }
        break;

      case "Not Checked In":
        if (event?.doublesEvent || event?.teamEvent) {
          const tempArr = [];

          if (players && Array.isArray(players)) {
            players?.forEach((teamPlayer) => {
              if (!teamPlayer?.checkedIn && !teamPlayer?.dropped) {
                tempArr.push(teamPlayer);
              } else {
                if (teamPlayer?.players) {
                  for (const _player of teamPlayer.players) {
                    if (!_player?.checkedIn && !_player?.dropped) {
                      tempArr.push(teamPlayer);
                      break;
                    }
                  }
                }
              }
            });
          }

          setFilteredPlayers(tempArr);
        } else {
          setFilteredPlayers(
            players && Array.isArray(players)
              ? players.filter((player) => !player.checkedIn && !player.dropped)
              : []
          );
        }
        break;

      case "Lists":
        if (event?.doublesEvent || event?.teamEvent) {
          const tempArr = [];
          let found = false;

          if (players && Array.isArray(players)) {
            players?.forEach((teamPlayer) => {
              found = false;
              if (teamPlayer?.players) {
                for (const _player of teamPlayer.players) {
                  if (_player?.listId) {
                    found = true;
                  } else {
                    found = false;
                    break;
                  }
                }
              }

              if (found) tempArr.push(teamPlayer);
            });
          }
          setFilteredPlayers(tempArr);
        } else {
          setFilteredPlayers(
            players && Array.isArray(players)
              ? players.filter((player) => player?.listId)
              : []
          );
        }
        break;

      case "No Lists":
        if (event?.doublesEvent || event?.teamEvent) {
          const tempArr = [];

          if (players && Array.isArray(players)) {
            players?.forEach((teamPlayer) => {
              if (teamPlayer?.players) {
                for (const _player of teamPlayer.players) {
                  if (!_player?.listId) {
                    tempArr.push(teamPlayer);
                    break;
                  }
                }
              }
            });
          }

          setFilteredPlayers(tempArr);
        } else {
          setFilteredPlayers(
            players && Array.isArray(players)
              ? players.filter((player) => !player?.listId)
              : []
          );
        }

        break;

      case "Dropped":
        setFilteredPlayers(
          players && Array.isArray(players)
            ? players.filter((player) => player.dropped)
            : []
        );
        break;

      case "Not Dropped":
        setFilteredPlayers(
          players && Array.isArray(players)
            ? players.filter((player) => !player.dropped)
            : []
        );
        break;

      default:
        setFilteredPlayers(null);
        setFilterType("");
    }
    // eslint-disable-next-line
  }, [filterType, players]);

  return (
    <EventRosterDefault
      organize={organize}
      setActiveTab={setActiveTab}
      event={event}
      authContext={authContext}
      playerStats={playerStats}
      players={players}
      setPlayers={setPlayers}
      filteredPlayers={filteredPlayers}
      setFilteredPlayers={setFilteredPlayers}
      subLoading={subLoading}
      setPlayer={setPlayer}
      setTeamPlayer={setTeamPlayer}
      optionsAnchorEl={optionsAnchorEl}
      setOptionsAnchorEl={setOptionsAnchorEl}
      setLoading={setLoading}
      setBulkAddEmailsOpen={setBulkAddEmailsOpen}
      setBulkAddOpen={setBulkAddOpen}
      setRefreshPlayers={setRefreshPlayers}
      player={player}
      armies={armies}
      teamPlayer={teamPlayer}
      bulkAddOpen={bulkAddOpen}
      bulkAddEmailsOpen={bulkAddEmailsOpen}
      loading={loading}
      filtersAnchorEl={filtersAnchorEl}
      setFiltersAnchorEl={setFiltersAnchorEl}
      filterType={filterType}
      setFilterType={setFilterType}
    />
  );
}
